// @flow
import idx from 'idx';
import gql from 'graphql-tag';
import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from 'components/Tabs';
import { graphql } from 'react-apollo';
import Text from 'components/Text';
import Image from 'components/Image';
import TabPanel from 'components/TabPanel';
import MediaObject from 'components/MediaObject';
import { AvatarImages } from 'constants/AvatarConstants';

import './styles/OrganizationPageHeader.scss';

type Props = {
  data: *,
  uuid: string,
  routePrefix: string,
  children: React.Node,
};

class OrganizationPageHeader extends React.Component<Props, *> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  getFullPath(path: string): string {
    return `${this.props.routePrefix}${path}`;
  }

  isActive(path: string): boolean {
    return this.context.router.isActive(this.getFullPath(path));
  }

  render() {
    const organization = idx(this.props, _ => _.data.organizations[0]);

    if (!organization) {
      return null;
    }

    const activeTab = this.isActive('/announcements') ? 0 : -1;

    return (
      <div className="OrganizationPageHeader">
        <div className="OrganizationPageHeader-detail">
          <MediaObject center gutter="small">
            <Image width={32} src={AvatarImages.ORG_AVATAR} />
            <Text size="large">{organization.name}</Text>
          </MediaObject>
        </div>
        <Tabs tabActive={activeTab}>
          <TabPanel
            to={this.getFullPath('/announcements')}
            title={
              <Text size="xxxsmall" smallCaps>
                messages
              </Text>
            }
            onClick={() => this.context.router.replace(this.getFullPath('/announcements'))}
          />
        </Tabs>
      </div>
    );
  }
}

const withOrganization = graphql(
  gql`
    query OrganizationPageHeader($uuid: String!) {
      organizations(uuids: [$uuid]) {
        uuid
        id
        name
      }
    }
  `,
  {
    options: ({ uuid }) => ({ variables: { uuid } }),
  }
);

export { OrganizationPageHeader };
export default withOrganization(OrganizationPageHeader);
